import type { IModeratorState } from "../reducers/moderator/moderator";
import type { BannedChatUser } from "../../types/socket-messages";
import { EMessageTypes, Status } from "../../types/working-model";

const withoutEntries = <K, V>(map: Map<K, V>, shouldRemove: (key: K, value: V) => boolean): Map<K, V> => {
	const updated = new Map(map);
	for (const [key, value] of map) {
		if (shouldRemove(key, value)) {
			updated.delete(key);
		}
	}
	return updated;
};

export const applyChatUserBan = (state: IModeratorState, bannedUser: BannedChatUser): IModeratorState => {
	const bannedProfile = Number(bannedUser.bl_profile || bannedUser.bl_profile_non_reg);
	if (!bannedProfile) return state;

	const profileKey = bannedUser.bl_profile ? "bl_profile" : "bl_profile_non_registered";
	const isBannedChatEntry = (key: string | number, message: any): boolean => {
		const isChatKey = typeof key === 'number' || key.startsWith(`${EMessageTypes.Chat}-`);
		return isChatKey && Number(message?.[profileKey]) === bannedProfile;
	};

	const updatedChat = new Map(state.chat);
	let visibleCountChange = 0;
	for (const [key, message] of state.chat) {
		if (!isBannedChatEntry(key, message)) {
			continue;
		}

		const wasDeleted = message.status === Status.Deleted;
		if (state.hideBannedChat) {
			updatedChat.delete(key);
			visibleCountChange -= wasDeleted ? 0 : 1;
		} else {
			updatedChat.set(key, { ...message, status: Status.Banned });
			visibleCountChange += wasDeleted ? 1 : 0;
		}
	}

	const updatedDeleted = withoutEntries(state.deletedMessages.messages, isBannedChatEntry);

	return {
		...state,
		chat: updatedChat,
		deletedMessages: {
			...state.deletedMessages,
			messages: updatedDeleted,
			totalCount: updatedDeleted.size,
		},
		sentToPresenter: withoutEntries(state.sentToPresenter, isBannedChatEntry),
		totalChatCount: state.totalChatCount + visibleCountChange,
		remeasureChatList: state.remeasureChatList + 1,
	};
};
